import { fromJS, List } from 'immutable';
import { CHOOSE_PICK_ENERGY, END_PICKS, PICK_STEP, PICKS_CANCEL, START_PICKS, SUBMIT_PICKS } from './constants';

/**
 * @param {object} source what the picks are for: { kind: TRAINER, handPosition, name } or
 *                        { kind: POWER, at, moveId, name }
 * @param {List} steps the card's trainer_steps or the move's power_steps
 */
export const startPicks = (source, steps) => ({
  type: START_PICKS,
  payload: fromJS({ source, steps: steps || List() }),
});

/** @param {string|number} at 'active' or a bench position */
export const choosePickEnergy = (from, at) => ({
  type: CHOOSE_PICK_ENERGY,
  payload: fromJS({ from, at }),
});

/** A Pokémon, and its energy cards if the step takes any. */
export const pickTarget = (from, at, energyIds = List()) => ({
  type: PICK_STEP,
  payload: fromJS({ from, at, energyIds }),
});

/** Cards from the hand or discard pile, by position. */
export const pickCards = (from, positions) => ({
  type: PICK_STEP,
  payload: fromJS({ from, positions }),
});

/** An energy type (Buzzap). */
export const pickType = (type) => ({
  type: PICK_STEP,
  payload: fromJS({ from: 'type', type }),
});

/** @param {Map} source as in startPicks */
export const submitPicks = (source, picks = List()) => ({
  type: SUBMIT_PICKS,
  payload: fromJS({ source, picks }),
});

export const picksCancel = () => ({
  type: PICKS_CANCEL,
});

export const endPicks = () => ({
  type: END_PICKS,
});
